export const LIMITS = {
  min: 1,
  max: 99999999,
};

export default {
  LIMITS,
};
